export const DEFAULT_LANG_UUID = '1d005e5b-c41a-45a6-82dc-d32229576b8e'
